import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Card = (props) => {
  const {
    title,
    imageSrc,
    imageAlt,
    description,
    moreLink = null,
    enableImagePreview = false
  } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <Col sm={12} md={5} lg={4}>
        <div className="card">

          {/* IMAGE */}
          <div
            onClick={() => enableImagePreview && setOpen(true)}
            style={{ cursor: enableImagePreview ? 'pointer' : 'default' }}
          >
            <img src={imageSrc} className="image-fluid" alt={imageAlt} />
          </div>

          <h4 className="title">{title}</h4>
          <p className="description">{description}</p>

          <div className="text-right">
            {moreLink && (
              <Link className="more-button" to={moreLink}>
                more <DoubleArrowRoundedIcon fontSize="1.2vw" />
              </Link>
            )}
          </div>
        </div>
      </Col>

      {/* IMAGE PREVIEW MODAL */}
      {enableImagePreview && (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent sx={{ p: 0 }}>
            <img
              src={imageSrc}
              alt={imageAlt}
              style={{ width: '100%', height: 'auto' }}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default Card;
